export default "__VITE_ASSET__080c35b7__"